export default function (url, mtgsig, data, cb) {
    const xhr = new XMLHttpRequest();
    let err = null;
    let body = '';
    const readyState = [];
    xhr.open('POST', url, true);
    xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
    if (mtgsig) {
        xhr.setRequestHeader('mtgsig', mtgsig);
    }
    xhr.onreadystatechange = function () {
        // 追踪状态变化
        readyState.push(xhr.readyState);
    };
    xhr.onloadend = function () {
        var _a;
        if (xhr.status === 200) {
            //根据服务器的响应内容格式处理响应结果
            if (((_a = xhr === null || xhr === void 0 ? void 0 : xhr.getResponseHeader('content-type')) === null || _a === void 0 ? void 0 : _a.indexOf('application/json')) !== -1) {
                try {
                    body = JSON.parse(xhr.responseText);
                }
                catch (e) {
                    err = {
                        type: 'parse json error',
                        responseText: xhr.responseText
                    };
                }
            }
            else {
                err = {
                    type: 'type not json',
                    responseText: xhr.responseText
                };
            }
        }
        else {
            if (err) {
                err.readyState = readyState;
                err.status = xhr.status;
                err.responseText = xhr.responseText;
            }
            else {
                err = {
                    type: 'status not 200',
                    readyState: readyState,
                    status: xhr.status,
                    responseText: xhr.responseText
                };
            }
        }
        // 请求结束
        cb(err, body);
    };
    xhr.onerror = function () {
        err = {
            type: 'xhr onerror'
        };
    };
    xhr.onabort = function () {
        err = {
            type: 'xhr onabort'
        };
    };
    let req = [];
    for (let key in data) {
        req.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
    }
    //将用户输入值序列化成字符串
    xhr.send(req.join('&'));
}
